import { ValidatePhoneNumber } from '@components/ValidatePhone/ValidatePhoneNumber';
import { FC, useEffect } from 'react';
import { useEditPhoneNumberController } from '@app/pages/Profile/useEditPhoneNumberController';
import { useSearchParams } from 'react-router-dom';

interface VerifyNewPhoneNumberProps {
  number: string;
  visible: boolean;
}

export const VerifyNewPhoneNumber: FC<VerifyNewPhoneNumberProps> = (props) => {
  const { setPhoneNumber, onResendCode, resetError, onTryAgain, onTryDifferentNumber, validateCode } =
    useEditPhoneNumberController();

  useEffect(() => {
    setPhoneNumber(props.number);
  }, [props.number]);
  return (
    <>
      <ValidatePhoneNumber
        validateCode={validateCode}
        onResendCode={onResendCode}
        onTryDifferentNumber={onTryDifferentNumber}
        onTryAgain={onTryAgain}
        visible={props.visible}
        resetError={resetError}
      ></ValidatePhoneNumber>
    </>
  );
};
